<template>
  <div class="home6-container">
    <div class="nav1">
      <div class="left">
        <div class="item tran-all"
          :class="[index==index1?'active':'',index!==index1&&(index+1)!=index1?'has-border':'']"
          @click="clickFirst(index,0)" v-for="(item,index) in navigation" :key="index">{{item.name}}
        </div>
      </div>
      <div class="right">
        <div>
          <span class="zsf-icon zsf-icon-touxiang"></span>
          <span class="ml-3">张三丰</span>
        </div>
        <div @click="quit" class="c-pointer">
          <span class="zsf-icon zsf-icon-tuichu"></span>
          <span class="ml-3">退出</span>
        </div>
      </div>
    </div>
    <div class="nav2">
      <div class="left">
        <div class="item tran-all" :class="index==index2?'active':''" @click="clickSecond(index)"
          v-for="(item,index) in navigation[index1].child" :key="index">
          <span>{{item.name}}</span>
        </div>
      </div>
      <div class="right">
        <div class="search">
          <el-input type="primary" placeholder="搜索人员查看位置" v-model="person" class="input"
            size="mini">
            <el-button type="primary" style="padding:12px;" slot="append" @click="search"
              icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="table-prefix-box11">
        <div class="search-box">
          <div class="item">
            <div class="span">姓名</div>
            <el-input v-model="obj.txt" placeholder="请输入姓名" size="mini"></el-input>
          </div>
          <div class="item">
            <div class="span">工号</div>
            <el-input v-model="obj.txt11" placeholder="请输入工号" size="mini"></el-input>
          </div>
          <div class="item">
            <span class="span">部门</span>
            <el-select size="mini" v-model="obj.select" placeholder="请选择部门">
              <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="span">工种</span>
            <el-select size="mini" v-model="obj.select11" placeholder="请选择工种">
              <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <!--<div class="item">-->
          <!--<span class="span">日期</span>-->
          <!--<el-date-picker size="mini" v-model="obj.date" type="date" placeholder="选择日期">-->
          <!--</el-date-picker>-->
          <!--</div>-->
          <!--<div class="item">-->
          <!--<div class="span">日期时间</div>-->
          <!--<el-date-picker size="mini" v-model="obj.dateTime" type="datetime"-->
          <!--placeholder="选择日期时间"></el-date-picker>-->
          <!--</div>-->
          <!--<div class="item">-->
          <!--<div class="span">数字</div>-->
          <!--<el-input v-model="obj.number" type="number" placeholder="请输入数字" size="mini"></el-input>-->
          <!--</div>-->
          <!--<div class="item">-->
          <!--<span class="span">日期</span>-->
          <!--<el-date-picker size="mini" v-model="obj.date" type="date" placeholder="选择日期">-->
          <!--</el-date-picker>-->
          <!--</div>-->
          <div class="item">
            <span class="span" title="日期范围日期范围日期范围">起止时间</span>
            <el-date-picker size="mini" class="dates" v-model="obj.dates" type="daterange"
              range-separator="到" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </div>
        <div class="btn-box">
          <el-button-group class="mr-10">
            <el-button @click="getData" title="搜索" size="mini" type="primary" icon="el-icon-check">
              搜索</el-button>
            <el-button @click="reset" title="刷新" size="mini" type="primary" icon="el-icon-refresh">
              刷新</el-button>
          </el-button-group>
          <el-button-group>
            <el-button @click="clickAdd" title="新增" size="mini" type="primary" icon="el-icon-plus">
              新增</el-button>
            <el-button @click="clickEdit" title="编辑" size="mini" type="primary" icon="el-icon-edit">
              编辑</el-button>
            <el-button @click="del" size="mini" type="primary" icon="el-icon-delete">删除</el-button>
            <!--<el-button tile="自定义图标" size="mini" type="info" icon="zsf-icon zsf-icon-guanli1"></el-button>-->
          </el-button-group>
        </div>
      </div>

      <div class="table11 mt-15">
        <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
          @current-change="handleCurrentChange" style="width:100%">
          <el-table-column label="ID" property="id" width="60"></el-table-column>
          <el-table-column label="基站编号">
            <template slot-scope="scope">
              <span>25</span>
            </template>
          </el-table-column>
          <el-table-column label="基站名称">
            <template slot-scope="scope">
              <span>基站名称</span>
            </template>
          </el-table-column>
          <el-table-column label="场景">
            <template slot-scope="scope">
              <span>甲板</span>
            </template>
          </el-table-column>
          <el-table-column label="安装地点">
            <template slot-scope="scope">
              <span>安装地点</span>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <span>其他说明</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination pt-10 t-center">
        <el-pagination background layout="total,sizes,prev,pager,next,jumper"
          :page-size="pagination.size" :page-sizes="[10,20,30,50]"
          :current-page.sync="pagination.page" :total="pagination.total" @size-change="changeSize"
          @current-change="changeCurrent"></el-pagination>
      </div>

      <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
        <div class="add-box11">
          <div class="o-hidden">
            <span class="span">名称</span>
            <el-input size="mini" v-model="addobj.name"></el-input>
          </div>
          <div class="o-hidden">
            <span class="span">名称</span>
            <el-input size="mini" v-model="addobj.name"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
          <el-button size="mini" type="primary" @click="submit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="footer">
      <img style="width:300px" src="../../common/images/logo.png" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { navigation } from "../../config.js";
import { tool } from "../../common/js/tool.js";
export default {
  data() {
    return {
      navigation: navigation,
      index1: 1,
      index2: 0,
      obj: {
        txt: "",
        txt11: "",
        select: "",
        select11: "",
        date: "",
        datas: "",
        dateTime: "",
        number: ""
      },
      list: [],
      currentRow: null,
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      tableLoading: false,
      addobj: { name: "" },
      addDialogShow: false
    };
  },

  computed: {},

  created() {
    this.getData();
  },

  mounted() {},

  methods: {
    clickAdd() {
      this.addDialogShow = true;
      this.currentRow = null;
    },
    clickEdit() {
      if (!this.currentRow) {
        tool.message("请在表格中选择数据", "error");
        return;
      }
      this.addDialogShow = true;
    },
    del() {
      if (!this.currentRow) {
        tool.message("请在表格中选择数据", "error");
      } else {
        this.$confirm("确定要删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$message({
            type: "success",
            duration: 1000,
            message: "操作成功!",
            onClose: () => {
              this.getData();
            }
          });
        });
      }
    },
    submit() {
      console.log(this.addobj);
      this.addDialogShow = false;
    },
    getData(flag) {
      let obj = Object.assign({}, this.obj);
      obj.page = flag ? this.pagination.page : 1;
      this.pagination.page = flag ? this.pagination.page : 1;
      console.log(this.obj, this.pagination, obj);
      this.tableLoading = true;
      setTimeout(() => {
        this.tableLoading = false;
        this.pagination.total = 222;
        this.list = [
          { id: 1 },
          { id: 2 },
          { id: 3 },
          { id: 4 },
          { id: 5 },
          { id: 6 },
          { id: 7 },
          { id: 8 },
          { id: 9 },
          { id: 10 }
        ];
      }, 10);
    },
    reset() {
      this.obj.page = 1;
      this.pagination.page = 1;
      this.getData();
    },
    changeCurrent(val) {
      this.pagination.page = val;
      this.obj.page = val;
      this.getData(true);
    },

    changeSize(e) {
      this.pagination.size = e;
      this.obj.pageSize = e;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      //console.log(val.id);
    },
    clickFirst(index1, index2) {
      this.index1 = index1;
      this.index2 = index2;
    },
    clickSecond(index) {
      this.index2 = index;
    },
    quit() {
      this.$confirm("确定要退出吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$router.push({ path: "/login" });
      });
    }
  },

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less">
.home6-container {
  width: 100%;
  height: 100%;
  background: #e6e8ef;
  padding: 15px;
  overflow-y: auto;
  .nav1 {
    display: flex;
    height: 44px;
    align-items: stretch;
    .left {
      flex: 1;
      display: flex;
      align-items: stretch;
      .item {
        color: #70789d;
        width: 105px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;
        font-size: 16px;
        &:hover {
          color: #30417a;
          font-weight: 600;
        }
        &.active {
          background: linear-gradient(
            360deg,
            rgba(39, 60, 158, 1) 0%,
            rgba(51, 72, 169, 1) 100%
          );
          border-radius: 10px 10px 0 0;
          color: white;
          font-weight: 600;
          &:before {
            background: none;
          }
        }
        &.has-border {
          &:before {
            display: block;
            content: "";
            width: 1px;
            height: 20px;
            position: absolute;
            right: 0;
            top: 12px;
            background: #70789d;
          }
        }
        &:last-child {
          &:before {
            background: none;
          }
        }
      }
    }
    .right {
      display: flex;
      justify-content: center;
      color: #3b3b3b;
      align-items: stretch;
      font-size: 12px;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
      }
    }
  }
  .nav2 {
    width: 100%;
    height: 36px;
    background: #21409d;
    border-radius: 0 10px 0 0;
    padding: 0 15px 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    .left {
      display: flex;
      align-items: stretch;
      height: 36px;
      .item {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        float: left;
        margin-right: 10px;
        display: flex;
        align-items: center;
        cursor: pointer;
        span {
          height: 14px;
          border-right: 1px solid rgba(255, 255, 255, 0.8);
          padding-right: 10px;
        }
        &:last-child {
          span {
            border-right: none;
          }
        }
        &:hover,
        &.active {
          color: white;
          span {
            font-weight: bold;
          }
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      .search {
        /*position: absolute;*/
        z-index: 10;
        /*left: 15px;*/
        /*top: 15px;*/
        .input {
          width: 200px;
          .el-input__inner {
            padding: 0 10px;
          }
        }
      }
    }
  }
  .box {
    width: 100%;
    height: auto;
    background: rgba(247, 247, 247, 1);
    box-shadow: 0px -5px 19px 0px rgba(155, 168, 227, 0.24);
    border-radius: 0 0 10px 10px;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
    .table-prefix-box11 {
      border: 1px solid #ebeef5;
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      padding: 15px 15px 0 15px;
      font-size: 12px;
      background: white;
      .search-box {
        flex: 1;
        width: 0;
        /*height: 40px;*/
        /*overflow: hidden;*/
        .el-range-separator {
          height: 28px;
          line-height: 28px !important;
        }
        .item {
          float: left;
          display: flex;
          margin-right: 20px;
          margin-bottom: 15px;
          align-items: center;
          justify-content: flex-start;
          background: #fafafa;
          padding: 0 0 0 10px;
          //border-radius: 4px 0 0 4px;
          border: 1px solid #dcdfe6;
          //border-right: none;
          .span {
            margin-right: 5px;
            width: 58px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .el-select,
          .el-input {
            width: 150px;
            border: none;
          }
          .dates {
            width: 250px !important;
          }
          .el-input__inner {
            width: 150px;
            padding: 0 10px;
            border-radius: 0px;
            border: none;
            border-left: 1px solid #dcdfe6;
          }
          .el-input__suffix {
            right: 3px;
          }
          .el-date-editor {
            .el-input__inner {
              padding: 0 10px 0 26px;
            }
          }
          .el-date-picker {
            height: 40px;
            line-height: 40px;
            display: flex;
            align-items: center;
          }
          .el-date-editor .el-range-separator {
            line-height: 40px;
          }
          .el-range-separator {
            width: 30px;
          }
        }
      }
      .btn-box {
        width: 400px;
        display: flex;
        justify-content: flex-end;
        .zsf-icon {
          font-size: 12px;
        }
      }
    }

    .table11 {
      width: 100%;
    }

    .add-box11 {
      font-size: 13px;
      & > div {
        display: flex;
        justify-content: flex-start;
        border-radius: 4px 0 0 4px;
        align-items: center;
        margin-bottom: 15px;
      }
      .span {
        width: 80px;
        display: inline-block;
        padding-right: 5px;
      }
    }
  }
  .footer {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
